import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ubt/ubt/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "license"
    }}>{`LICENSE`}</h3>
    <p>{`Licensed under `}<a parentName="p" {...{
        "href": "https://github.com/mahadeer/ubt/blob/master/LICENSE"
      }}>{`MIT License`}</a>{` and authorized by us to use free of charge as well.`}</p>
    <blockquote>
      <p parentName="blockquote">{`We will be happy if you could cite the project anywhere on your software/tools license.`}</p>
    </blockquote>
    <p>Please read the fun stuff about Licensing <a href="https://opensource.guide/legal/" target="_blank">here</a></p>
    <h3 {...{
      "id": "crates-that-made-ubt-possible"
    }}>{`Crates that made UBT possible`}</h3>
    <p>{`We want to thank and honor the following crates,`}</p>
    <ul>
    <li><a href="https://crates.io/crates/roxmltree" target="_blank">roxmltree</a></li>
    <li><a href="https://crates.io/crates/regex" target="_blank">regex</a></li>
    <li><a href="https://crates.io/crates/fs_extra" target="_blank">fs_extra</a></li>
    <li><a href="https://crates.io/crates/glob" target="_blank">glob</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      